import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationSnConstant {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    // static readonly REMOVE_POI_LABEL = "Remove POI";
    static COPY_APPLICANT_TO_OWNER_LABEL = "Copy applicant to owner";
    static DESCRIPTION_LABEL_1 = "Search the map to find the POI for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct POI and click on the POI. Click on 'add POI' in the window that appears on the map after you selected the POI.";
    static DESCRIPTION_LABEL_3 = "The POI will be added and the fields must be completed for the POI. Please note that only one POI can be added.";
    static PROPERTY_REQUIRED = "Please select a POI before continuing with the create application process";
    static STREET_OR_FEATURE_LABEL = "Are you requesting the renaming of a street or feature?";
    static PUBLIC_OR_PRIVATE_LABEL = "Is the street public or private?";
    static PRIVATE_STREET_AREA_OR_ESTATE_NAME_LABEL = "Private street area or estate name";
    static IS_NEW_DEVELOPMENT_NAME_LABEL = "Is the street / feature an existing street or a new development.";
    static HAVE_EXISTING_NAME_LABEL = "Does the street / feature have an existing name?";
    static CURRENT_NAME_LABEL = "Current name?";
    static LOCATION_DESCRIPTION_LABEL = "Description of the street's / feature's location";
    static WARD_LABEL = "Ward of the street / feature";
    static PROPOSED_NAME_LABEL = "Proposed name of the street / feature: First choice";
    static PROPOSED_NAME_LANGUAGE_LABEL = "What is the language of the name / feature?";
    static PROPOSED_NAME_MEANING_LABEL = "What is the meaning of the name / feature?";
    static PROPOSED_NAME_ORIGIN_LABEL = "Give the origin of the name if you know it and rationale for changing the name. Also provide the significance of the name.";
    static PROPOSED_ALTERNATIVE_NAME_LABEL = "Alternative name of the street / feature:";
    static LANGUAGE_OF_THE_ALTERNATIVE_NAME_LABEL = "What is the language of the alternative name?";
    static MEANING_OF_THE_ALTERNATIVE_NAME_LABEL = "What is the meaning of the alternative name?";
    static FEATURE_TYPE_LABEL = "Which feature is the proposed name intended? (e.g. post office, railway station, town, township, suburb, mountain, settlement, village)";
    static REASON_FOR_CHANGE_LABEL = "In the case of a proposed change of a name, give the reasons for the change ";
    static REMOVE_FEATURE_LABEL = "Remove feature";
    static FEATURES_FORM_ARRAY_NAME = "features";
    static LOCATION_FORM_GROUP_NAME = "locationForm";
    static STREET_OR_FEATURE_FORM_CONTROL_NAME = "streetOrFeature";
    static PUBLIC_OR_PRIVATE_FORM_CONTROL_NAME = "publicOrPrivate";
    static PRIVATE_STREET_AREA_OR_ESTATE_NAME_FORM_CONTROL_NAME = "areaEstateName";
    static IS_NEW_DEVELOPMENT_FORM_CONTROL_NAME = "isNewDevelopment";
    static HAVE_EXISTING_NAME_FORM_CONTROL_NAME = "haveExistingName";
    static CURRENT_NAME_FORM_CONTROL_NAME = "currentName";
    static LOCATION_DESCRIPTION_FORM_CONTROL_NAME = "locationDescription";
    static WARD_FORM_CONTROL_NAME = "ward";
    static PROPOSED_NAME_FORM_CONTROL_NAME = "proposedName";
    static PROPOSED_NAME_LANGUAGE_FORM_CONTROL_NAME = "proposedNameLanguage";
    static PROPOSED_NAME_MEANING_FORM_CONTROL_NAME = "proposedNameMeaning";
    static PROPOSED_NAME_ORIGIN_FORM_CONTROL_NAME = "proposedNameOrigin";
    static PROPOSED_ALTERNATIVE_NAME_FORM_CONTROL_NAME = "alternativeNames";
    static FEATURE_TYPE_FORM_CONTROL_NAME = "featureType";
    static REASON_FOR_CHANGE_FORM_CONTROL_NAME = "reasonForChange";
    static DUPLICATE_MESSAGE = "The selected POI has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static STREET_OR_FEATURE_LOOKUPS = [{
            code: "Street", value: "Street"
        }, {
            code: "Feature", value: "Feature"
        }];
    static PUBLIC_OR_PRIVATE_LOOKUPS = [{
            code: "Public", value: "Public"
        }, {
            code: "Private", value: "Private"
        }];
    static IS_NEW_DEVELOPMENT_LOOKUPS = [
        { code: "Existing", value: "Existing" },
        { code: "New development", value: "New development" }
    ];
    static HAVE_EXISTING_NAME_LOOKUPS = [{
            code: "No", value: "No"
        }, {
            code: "Yes", value: "Yes"
        }];
    static REASON_FOR_CHANGE_NAME_LOOKUPS = [{
            code: "Public", value: "Public"
        }, {
            code: "Private", value: "Private"
        }];
    static VALIDATION_MESSAGES = {
        streetOrFeature: {
            required: `Street or feature ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, publicOrPrivate: {
            required: `Public or public ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, areaEstateName: {
            required: `Area estate name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, isNewDevelopment: {
            required: `Is new development ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, haveExistingName: {
            required: `Have existing name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, currentName: {
            required: `Current name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, locationDescription: {
            required: `Location description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, ward: {
            required: `Ward ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, proposedName: {
            required: `Proposed name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, proposedNameLanguage: {
            required: `Proposed name language ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, proposedNameMeaning: {
            required: `Proposed name meaning ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, proposedNameOrigin: {
            required: `Proposed name origin ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, featureType: {
            required: `Feature type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, reasonForChange: {
            required: `Reason for change ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, name: {
            required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, language: {
            required: `Language ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, meaning: {
            required: `Meaning ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
}
